module.exports = __webpack_public_path__ + "static/media/hotstardisputeslistsearch.6cfc8c8f.svg";